<template>
  <div class="upload">
    <Upload
      ref="upload"
      :class="{ disabled: disabled }"
      :action="uploadImgUrl"
      :data="{ typeId: typeId }"
      :name="name"
      :show-upload-list="false"
      :on-success="handleAvatarSuccess"
      :format="['jpg', 'jpeg', 'png']"
      :max-size="maxSize"
      type="drag"
      style="display: inline-block; width: 58px"
    >
      <i-img
        v-for="(item, index) in picList"
        :key="index"
        class="avatar"
        :src="item"
        :type="picType"
      />
      <div
        v-if="!picList.length"
        style="width: 58px; height: 58px; line-height: 58px"
      >
        <Icon type="ios-camera" size="20"></Icon>
      </div>
    </Upload>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "multipartFiles",
    },
    maxSize: {
      type: Number,
      default: 2048,
    },
    showFileList: {
      type: Boolean,
      default: false,
    },
    typeId: {
      type: Number,
      default: 6,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isButton: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: "上传文件",
    },
  },
  data() {
    return {
      isLoading: false,
      uploadImgUrl: window.config.newapi + "/base/fileUploadNew", //图片上传地址 ;
    };
  },
  computed: {
    handleBeforeUpload() {},
    picType() {
      let str = "";
      switch (this.typeId) {
        case 1:
          str = "hand";
          break;
        case 4:
          str = "user";
          break;
        case 6:
          str = "other";
          break;
      }
      return str;
    },
    picList() {
      return this.value ? this.value.split(",") : [];
    },
  },
  methods: {
    remove(index) {
      let val = this.value.split(",");
      val.splice(index, 1);
      this.$emit("input", val.join(","));
    },
    handleAvatarSuccess(res, file) {
      let val = this.multiple ? this.modelValue + "," + res.result : res.result;
      this.$emit("input", val);
      this.$emit("success", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.upload {
  .avatar {
    max-width: 100%;
    max-height: 100%;
    vertical-align: top;
  }
}
</style>
